import { Presentation } from './../../../_models/task_template_topology_answer_presentation';

import { TaskTemplate } from 'src/app/_models/task_template';
import { Slot } from './../../../_models/task_template_slot';

import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { QuizService } from '../../../_services/quiz.service';


declare var window: any;

@Component({
  selector: 'app-question-template-create',
  templateUrl: './task-template-create.component.html',
  styleUrls: ['./task-template-create.component.css']
})


export class TaskTemplateCreateComponent implements OnInit {
  taskTemplate = new TaskTemplate()

  loading=false
  newTemplateName=""
  partModal:any


  sources=["template","system","part","expression"]
  valueTypes=["DATATYPE_INTEGER", "DATATYPE_TEXT","DATATYPE_IMAGE"]
  boldManagers=["A", "B","C","D","E","F","G","H","I","J"]
  topologies=["onepart", "multipart"]
  presentationTypes=["INPUT","RADIOGROUP"]
  myForm = new FormGroup({})
  formData  = new HttpParams();

  constructor(private router:Router,private quizService:QuizService) {
      this.myForm.addControl("templateName",  new FormControl("", [Validators.required]))
      this.taskTemplate.parts[0].name="p00"
      this.initSlotControls(this.taskTemplate.parts[0].name,this.taskTemplate.parts[0].source)
      this.initLayout(0,0)

     }
  get f() {
    return this.myForm.controls;
  }

  ngOnInit(): void {}


  submit() {
    this.loading=true

    this.formData.append("templateName",this.myForm.get("templateName").value)


    for(let i=0; i <  this.taskTemplate.parts.length;i++){
       let part= this.taskTemplate.parts[i]
       let partName = this.partName(i)
       let fPartForm =this.readSlotValues(partName)
       let formPartParams=[]
       if(part.source =="system"){
        for(let ii=0; ii <  part.params.length;ii++){
           let param = part.params[ii]
         formPartParams.push( this.readSlotValues(param.name))
        }
        fPartForm.append('params',formPartParams.toString())
       }
       this.formData.append("parts",fPartForm.toString())
       //formParts.push(fPartForm)
    }


    for(let i=0; i <  this.taskTemplate.layouts.length;i++){
      let topology = this.taskTemplate.layouts[i]
      this.formData.append(`m${i}_topology`,this.myForm.get(`m${i}_topology`).value)
      for(let ii=0; ii <  topology.body.length;ii++){
        let pName =`m${i}_${ii}_body`
        this.formData.append(pName,this.myForm.get(pName).value)
      }
    let answer =topology['answer']
    let name = `m${i}_answer`
    this.readSlotValues(name)
    let presentations = answer['presentations']
    for(let iii=0;iii <  presentations.length; iii++){
      let presentationName =`m${i}_${iii}_presentationtype`
      this.formData.append(presentationName,this.myForm.get(presentationName).value)
      let presentation = presentations[iii]
      let answerOptions = presentation['answerOptions']
      for(let kk=0;iii <  answerOptions.length; kk++){
        let answerOptionName =`m${i}_${iii}_${kk}_answeroption`
        this.readSlotValues(answerOptionName)
      }
    }
  }


     this.quizService.createTaskTemplate(this.formData).subscribe(
      xx=>{
         if(xx['isnew'] || xx['is_match']){
           let templateId = xx['questionTemplateId']
           this.loading=false
           this.router.navigate(["/task/template/show",templateId])
          }
       }
     )

    this.loading=false
    this.formData = new HttpParams()
  }

  onTemplateNameChange() {
    this.newTemplateName = this.myForm.get("templateName").value
  }

  addMainBody(lIndex:number){
    let layout = this.taskTemplate.layouts[lIndex]
    layout.body.push("")
    this.taskTemplate.layouts=this.taskTemplate.layouts


    this.myForm.addControl(`m${lIndex}_${layout.body.length-1}_body`, new FormControl("",[Validators.required]))
  }
  removeMainBody(lIndex:number,bIndex:number){
    let layout = this.taskTemplate.layouts[lIndex]
    layout.body.splice(bIndex,1)
    this.myForm.removeControl(`m${lIndex}_${bIndex}_body`)
  }
  addMainPresentation(tIndex:number,){
    let topology = this.taskTemplate.layouts[tIndex]
    let answer = topology['answer']
    this.initPresentationControls(tIndex, answer['presentations'].length)
    answer['presentations'].push( new Presentation())
  }
  removeMainPresentation(tIndex:number, pIndex:number){
    let topology = this.taskTemplate.layouts[tIndex]
    let answer = topology['answer']
    answer['presentations'].splice(pIndex,1)
    this.removePresentationControls(tIndex,pIndex)
  }
  addMainAnswerParam(){}

  onChangeMainPartSource(partIndex:number){
    let part = this.taskTemplate.parts[partIndex]
    let formValue = this.myForm.get(`${part.name}_source`).value
    part.source=formValue
    this.taskTemplate.parts[partIndex]=part
    if(formValue=="system"){
      this.addMainPartParam(partIndex)
    }
  }
  onChangeMainPresentationType(tIndex:number,pIndex:number){
    let cName =`m${tIndex}_${pIndex}_presentationtype`
    let formValue = this.myForm.get(cName).value
    let topology = this.taskTemplate.layouts[tIndex]
    let answer = topology['answer']
    let presentation:Presentation = answer['presentations'][pIndex]
    presentation.presentationType=formValue
    answer['presentations'][pIndex]=presentation
    topology['answer']=answer
    this.taskTemplate.layouts[tIndex]=topology

    if(formValue=="RADIOGROUP"){
      this.addMainAnswerOption(tIndex,pIndex)
    }
  }
  addMainAnswerOption(tIndex:number,pIndex:number){
    let layout = this.taskTemplate.layouts[tIndex]
    let answer = layout['answer']
    let presentation =answer['presentations'][pIndex]
    let aIndex =presentation['answerOptions'].length
    let slotName =`m${tIndex}_${pIndex}_${aIndex}_answeroption`
    this.initSlotControls(slotName,"system")
    let answerOption=new Slot()
    answerOption.source="system"
    presentation['answerOptions'].push(answerOption)
    answer['presentations'][pIndex]=presentation
    layout['answer']=answer
    this.addMainAnswerOptionParam(tIndex,pIndex,aIndex)

  }
  removeMainAnswerOption(tIndex:number,pIndex:number, aIndex:number){
    let layout = this.taskTemplate.layouts[tIndex]
    let answer = layout['answer']
    let presentation =answer['presentations'][pIndex]
    presentation['answerOptions'].splice(aIndex,1)
    let slotName =`m${tIndex}_${pIndex}_${aIndex}_answeroption`
    this.removeSlotControls(slotName)

  }
  addMainAnswerOptionParam(tIndex:number,pIndex:number, aIndex:number){
    let layout = this.taskTemplate.layouts[tIndex]
    let answer = layout['answer']

    let presentation =answer['presentations'][pIndex]
    let answerOption = presentation['answerOptions'][aIndex]

    let paramIndex =answerOption['params'].length
    answerOption['params'].push(new Slot())

    let slotName =`m${tIndex}_${pIndex}_${aIndex}_${paramIndex}`

    this.initSlotControls(slotName,"part")

    presentation['answerOptions'][aIndex]=answerOption
    answer['presentations'][pIndex]=presentation
    layout['answer']=answer


  }
  removeMainAnswerOptionParam(tIndex:number,pIndex:number, aIndex:number,paramIndex:number){
    let layout = this.taskTemplate.layouts[tIndex]
    let answer = layout['answer']
    let presentation =answer['presentations'][pIndex]
    let answerOption= presentation['answerOptions'][aIndex]
    answerOption['params'].splice(paramIndex,1)
    let slotName =`m${tIndex}_${pIndex}_${aIndex}_${paramIndex}`

    this.removeSlotControls(slotName)
  }
 addMainPart(source:string){
    let partIndex = this.taskTemplate.parts.length
    let partName = this.partName(partIndex)
    this.initSlotControls(partName,source)
    let part = new Slot()
    part['name']=partName
    part['source']=source
    this.taskTemplate.parts.push(part)
    if(source=='system'){
      this.addMainPartParam(partIndex)
    }


 }
 initPresentationControls(tIndex:number,pIndex:number){
  let indexPrefix =`m${tIndex}_${pIndex}_answeroption`
  this.myForm.addControl(`m${tIndex}_${pIndex}_presentationtype`, new FormControl("", [Validators.required]))
  this.initSlotControls(indexPrefix,"system")
 }
 removePresentationControls(tIndex:number,pIndex:number){
  let indexPrefix =`m${tIndex}_${pIndex}_answeroption`
  this.myForm.removeControl(`m${tIndex}_${pIndex}_presentationtype`)
  this.removeSlotControls(indexPrefix)
 }
 initSlotControls(slotName:string, source:string){
  this.myForm.addControl(slotName, new FormControl(slotName, [Validators.required]))
  this.myForm.addControl(slotName+"_source", new FormControl(source, [Validators.required]))
  this.myForm.addControl(slotName+"_value", new FormControl("", [Validators.required]))
  this.myForm.addControl(slotName+"_valuetype", new FormControl("", [Validators.required]))
  this.myForm.addControl(slotName+"_bm", new FormControl("", [Validators.required]))
 }
 removeSlotControls(slotName:string){
  this.myForm.removeControl(slotName)
  this.myForm.removeControl(slotName+"_source")
  this.myForm.removeControl(slotName+"_value")
  this.myForm.removeControl(slotName+"_valuetype")
  this.myForm.removeControl(slotName+"_bm")
 }


 removePart(partNumber:string){
  for(let i=0;i<this.taskTemplate.parts.length;i++){
    let partName =this.taskTemplate.parts[i]['name']
      if(partNumber==partName){
          this.taskTemplate.parts.splice(i,1)
          this.removeSlotControls(partNumber)
          break
        }
    }
}
addMainPartParam(mainPartIndex:number){
  let myPart=this.taskTemplate.parts[mainPartIndex]
  let myPartName =myPart['name']
  let myParameter =new Slot()
  myParameter.name=`${myPartName}_param0${myPart.params.length}`
  this.initSlotControls(myParameter.name,"template")
  myPart.params.push(myParameter)
  this.taskTemplate.parts[mainPartIndex]=myPart

}


 addPartPopUp(){
  this.partModal = new window.bootstrap.Modal(
    document.getElementById('myTaskPartModal')
  );
  this.partModal.show()

 }

partSourceGiven(value:string){
  Promise.resolve(null).then(() => {
    this.addMainPart(value)
    this.closeModal()
  })
}
closeModal(){
  this.partModal.hide()
}
removePartParam(partNumber:string,parameterName:string){
  for(let i=0;i<this.taskTemplate.parts.length;i++){
    let myPart=this.taskTemplate.parts[i]
    let partName =myPart['name']
      if(partNumber==partName){
          this.taskTemplate.parts[i]=this._removeParamControls(myPart,parameterName)
          break
        }
    }

}
_removeParamControls(part:Slot, paraName:string){
  for(let i=0;i<part.params.length;i++){
    let myParamPart=part.params[i]
    let myParameterName =myParamPart['name']
      if(paraName==myParameterName){
        part.params.splice(i,1)
        this.removeSlotControls(myParameterName)
        break

      }
    }
    return part
}



initLayout(tIndex:number,pIndex:number){
    this.myForm.addControl(`m${tIndex}_topology`, new FormControl("", [Validators.required]))
    let name = `m${tIndex}_answer`
    this.initSlotControls(name,"parts")
    this.myForm.addControl(`m${tIndex}_${pIndex}_presentationtype`, new FormControl("", [Validators.required]))
}

partName(index:number){
  return index<10?`p0${index}`: `p${index}`
}

readSlotValues(slotName:string){
  let formData = new HttpParams()

  formData.append("name",this.myForm.get(slotName).value)
  formData.append(slotName+"_source",this.myForm.get(slotName+"_source").value)
  formData.append(slotName+"_value",this.myForm.get(slotName+"_value").value)
  formData.append(slotName+"_valuetype",this.myForm.get(slotName+"_valuetype").value)
  formData.append(slotName+"_bm",this.myForm.get(slotName+"_bm").value)
  return formData
 }
}
